import { ComponentProps, ReactElement, lazy, Suspense } from 'react';
import { unstable_HistoryRouter as HistoryRouter, Routes, Route } from 'react-router-dom';

import ILazyComponent from '^types/common/ILazyComponent';
import {
  getRootPageRoutePath, getErrorRouteUrl,
} from '^utils/routingHelpers';
import sharedHistory from '^sharedHistory';
import ErrorPage from '^components/ErrorPage';
import PageSkeleton from '^components/PageSkeleton';

// RR7 does not re-export its internal `History` type; derive the exact prop type
// the router expects from the component itself (stays correct across RR7 patches).
type RouterHistory = ComponentProps<typeof HistoryRouter>['history'];

const Root = lazy((): Promise<ILazyComponent> => import('^pages/Root'));

const RoutingRules = (): ReactElement => (
  <Suspense fallback={<PageSkeleton />}>
    {/*
      history@5's BrowserHistory/MemoryHistory are structurally compatible with the
      router but lack RR7-internal members (createURL/encodeLocation). RR7 only reads
      the v5-shared surface (push/replace/listen/location/action) at runtime, so the
      cast is safe. Documented fallback per MIGRATION-PLAN §3.D / Risk R8.
    */}
    <HistoryRouter history={sharedHistory as unknown as RouterHistory}>
      <Routes>
        <Route
          element={<Root />}
          path={getRootPageRoutePath()}
        />

        <Route
          element={<ErrorPage />}
          path={getErrorRouteUrl()}
        />
      </Routes>
    </HistoryRouter>
  </Suspense>
);

export default RoutingRules;
